import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { Locations } from "../../types/locations";
import { AddressTypes } from "../../types/addressTypes";
import {  uploaddocuments } from "../../types/document";
import { EnvelopeDocuments } from "../../types/navBar";

interface RootState{
    locations:Locations[];
    address:AddressTypes[];
    selectedaddress:AddressTypes|null;
    search:AddressTypes[];
    documents:uploaddocuments[];
    uploaddocuments:EnvelopeDocuments[];
    status:'idle'|'loading'|'succeeded'|'failed';
    error:string|null;
}

const initialState:RootState={
    locations:[],
    address:[],
    selectedaddress:null,
    search:[],
    documents:[],
    uploaddocuments:[],
    status:'idle',
    error:null,
}

export const locationSlice=createSlice({
    name:"locations",
    initialState,
    reducers:{
        SetLocation:(state,action:PayloadAction<Locations[]>)=>{
            state.locations=action.payload;
            state.status='succeeded';
            state.error=null;
        },
       setLoading:(state)=>{
        state.status='loading';
        state.error=null;
       },
       setError:(state,action:PayloadAction<string>)=>{
        state.error=action.payload;
        state.status='failed'
       },
       AddLocation: (state, action: PayloadAction<Locations>) => {
        if (!Array.isArray(state.locations)) {
            state.locations = [];
        }
        state.locations.push(action.payload);
        state.status = 'succeeded';
        state.error = null;
    },
    
       UpdateLocation:(state,action:PayloadAction<Locations>)=>{
        if (Array.isArray(state.locations)) {
        const index=state.locations.findIndex((x)=>x.id===action.payload.id);
        if(index !==-1){
            state.locations[index]=action.payload;
        }
         }
        state.status='succeeded';
        state.error=null;
       },
       locationDelete: (state, action: PayloadAction<string>) => {
        const index = state.locations.findIndex((c) => c.id === action.payload);
        if (index !== -1) {
        state.locations = state.locations.filter(c => c.id !== action.payload);
        }
        state.status = 'succeeded';
        state.error = null;
      },
      setAddressTypes:(state,action:PayloadAction<AddressTypes[]>)=>{
        state.address=action.payload;
        state.status='succeeded';
        state.error=null
      },
      setDocumentData:(state,action:PayloadAction<uploaddocuments[]>)=>{
        state.documents=action.payload;
        state.status='succeeded';
        state.error=null;
      },
      setUploadDocumentData:(state,action:PayloadAction<EnvelopeDocuments>)=>{
        state.uploaddocuments.push(action.payload);
        state.status='succeeded';
        state.error=null;
      },
      clearUploadDocumentData:(state)=>{
        state.uploaddocuments=[];
        state.status='succeeded';
        state.error=null;
      },
      clearDocuments:(state)=>{
        state.documents=[];
        state.status='succeeded';
        state.error=null;
      }
     

     
     
    }
})

export const {SetLocation,setLoading,setError,UpdateLocation,AddLocation,setAddressTypes,locationDelete,setDocumentData,setUploadDocumentData,clearUploadDocumentData,clearDocuments}=locationSlice.actions;
export default locationSlice.reducer;